import LocalizationEntity from "../../../../../domain/entities/LocalizationEntity";
import LocalizationList from "./dictionaries/LocalizationList";

const GetAvailableLanguagesApiImpl = async (): Promise<LocalizationEntity[]> => LocalizationList;

export default GetAvailableLanguagesApiImpl;